window.renderSvgInline = (function() {
  const _logger = window.mcb.utilities.createLogger('renderSvgInline', 'SVG Helper');

  return function(elem) {
    fetch(elem.src)
      .then(response => response.text())
      .then(svgContent => {
        if (!(svgContent === null || svgContent.trim().length === 0)) {
          elem.parentElement.innerHTML = svgContent;
        } else {
          _logger.warn('Empty SVG content from:', elem.src);
        }
      })
      .catch(error => {
        _logger.error('Error fetching SVG file:', error);
      });
  };
})();
